var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"height":"1000px"},attrs:{"src":_vm.url,"frameborder":"0","scrolling":"no","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }